const imagesContext = require.context(
    '../assets/projects',
    true,
    /\.(jpg|jpeg|png|webp)$/i
)

const categoryTitles = {
    driveways: {
        en: 'Concrete Driveway',
        es: 'Entrada de Concreto'
    },

    patios: {
        en: 'Concrete Patio',
        es: 'Patio de Concreto'
    },

    sidewalks: {
        en: 'Concrete Sidewalk',
        es: 'Banqueta de Concreto'
    },

    slabs: {
        en: 'Concrete Slab',
        es: 'Losa de Concreto'
    },

    commercial: {
        en: 'Commercial Concrete',
        es: 'Concreto Comercial'
    },

    other: {
        en: 'Custom Concrete',
        es: 'Concreto Personalizado'
    }
}

export const projectCategories = [
    'all',
    'driveways',
    'patios',
    'sidewalks',
    'slabs',
    'commercial',
    'other'
]

const projectPaths = imagesContext
    .keys()
    .sort((firstPath, secondPath) =>
        firstPath.localeCompare(secondPath, undefined, {
            numeric: true,
            sensitivity: 'base'
        })
    )

const projects = projectPaths.map((path, index) => {
    const cleanPath = path.replace('./', '')
    const [category] = cleanPath.split('/')

    const baseTitle =
        categoryTitles[category] || categoryTitles.other

    return {
        id: index + 1,
        image: imagesContext(path),
        category,
        fileName: cleanPath.split('/').pop(),

        title: {
            en: baseTitle.en,
            es: baseTitle.es
        }
    }
})

export default projects